<ion-header class="identity-provider-login-header">
  <app-header pageName="{{'LOGIN'| translate}}">
  </app-header>
</ion-header>

<div class="ion-padding-vertical">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-list>
      <ion-item lines="full" class="ion-margin-end">
        <ion-input data-cy="identityUserNameInput" class="card-num-input" type="text" [formControlName]="sirsiPolarisProviderAvail || innovativeProviderAvail ? 'barcode' : 'username'"
          placeholder="{{ (sirsiPolarisProviderAvail || innovativeProviderAvail ? 'BARCODE' : 'USERNAME') | translate }}">
        </ion-input>
        <ion-icon [name]="sirsiPolarisProviderAvail || innovativeProviderAvail ? 'barcode' : 'person'" size="small" slot="start"></ion-icon>
      </ion-item>
      <ion-item lines="full" class="ion-margin-end">
        <ion-input data-cy="identityPasswordInput" class="card-num-input" type="password"
          [formControlName]="!innovativeProviderAvail ? 'password' : 'pin'"
          placeholder="{{ (!innovativeProviderAvail ? 'PASSWORD' : 'PIN') | translate}}">
        </ion-input>
        <ion-icon [name]="!innovativeProviderAvail ? 'lock-closed' : 'key'" size="small" slot="start"></ion-icon>
      </ion-item>
    </ion-list>
    <ion-row class="ion-margin-top">
      <ion-col class="ion-padding-horizontal">
        <ion-button color="eprintprimary" data-cy="identitySubmitBtn" expand="full" type="submit" [disabled]="!form.valid">
          {{ 'SUBMIT' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</div>